module.exports = __webpack_public_path__ + "static/icons/icon-unlock--black-a71965ac956901dfc24ab730bf370592.svg";